import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import _ from 'lodash';
import DropZone from 'react-dropzone';
import Select from 'react-select';
import Creatable from 'react-select/lib/Creatable';
import 'react-select/dist/react-select.css';
import MdFilterNone from 'react-icons/lib/md/filter-none';
import { DateField } from './schedule_utils';

import { withAuth } from '../../actions/';
import { documentTypes } from '../../constants';
import { camelToTitle, formatDate } from '../../utils';

const documentTypeOptions = documentTypes.filter(dt => dt !== 'projectAssessment').map(type => {
  return {
    value: type.replace(/\s/g, ''),
    label: camelToTitle(type)
  }
});

const FilePreview = ({ file }) => {
  return (
    file.type.startsWith('image')
      ? <img src={file.preview} alt="Preview" />
      : <span><MdFilterNone size={20} /></span>
  );
}

FilePreview.propTypes = {
  file: PropTypes.object.isRequired
}


class DocumentForm extends Component {
  // static PropTypes = {
  //   projectId: PropTypes.string.isRequired,
  //   doc: PropTypes.object,
  //   file: PropTypes.object.isRequired,
  //   documentTags: PropTypes.array.isRequired,
  //   index: PropTypes.number,
  //   isVersionForm: PropTypes.bool,
  //   isDeleteForm: PropTypes.bool,
  //   onCancel: PropTypes.func.isRequired,
  //   onUploaded: PropTypes.func.isRequired,
  //   onDeleted: PropTypes.func.isRequired,
  // }

  constructor(props) {
    super(props);
    this.state = {
      ...this.getInitialState(props.doc),

      progressText: '',
      errorText: '',

      versionFile: null,
      fileNameInvalid: false,
      documentTypeInvalid: false,
      documentDate: null,
    }

    // Events on form elements
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleTagsChange = this.handleTagsChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleUploadVersion = this.handleUploadVersion.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);

    // Ajax requests to Blob storage, API
    this.notifyError = this.notifyError.bind(this);
    this.uploadNew = this.uploadNew.bind(this);
    this.deleteBlob = this.deleteBlob.bind(this);
    this.postDocumentToAPI = this.postDocumentToAPI.bind(this);
    this.putDocumentToAPI = this.putDocumentToAPI.bind(this);
    this.delDocumentToAPI = this.delDocumentToAPI.bind(this);
  }

  getInitialState(doc) {
    documentTypeOptions.forEach(function (item) {
      if (typeof (item.value) === 'string')
        item.value = item.value.toUpperCase()
    })

    const state = { tags: [], documentType: {} };
    if (doc) {
      state.fileName = doc.fileName;
      state.tags = doc.tags;

      state.documentType = _.find(documentTypeOptions, { value: doc.documentType.toUpperCase() });
    }

    else {
      state.fileName = this.props.file.name.split('.')[0];
    }
    return state;
  }

  UNSAFE_componentWillMount() {
    this.props.doc &&
      this.setState({ 'documentDate': this.props.doc.documentDate });
  }

  handleNameChange(e) {
    const fileName = e.target.value;
    this.setState({
      fileName,
      fileNameInvalid: !fileName || fileName.length == 0 || fileName.length > 150 //perform this check to avoid long file names
    });
  }

  handleTypeChange(value) {
    const newType = value || {};
    this.setState({
      documentType: newType,
      documentTypeInvalid: _.isEmpty(newType)
    });
  }

  handleTagsChange(value) {
    const newTags = value || [];
    this.setState({ tags: newTags });
  }

  handleCancel() {
    this.props.onCancel(this.props.index);
  }

  handleUpload() {
    const { projectId } = this.props;
    const sasEndpoint = `projects/${projectId}/documents/sas`;

    withAuth(
      { method: 'get', url: sasEndpoint },
      this.uploadNew,
      this.notifyError
    );

    this.setState({ progressText: 'uploading' });
  }

  handleDelete() {
    const { projectId } = this.props;
    const sasEndpoint = `projects/${projectId}/documents/sas`;

    withAuth(
      { method: 'get', url: sasEndpoint },
      this.deleteBlob,
      this.notifyError
    );

    this.setState({ progressText: 'deleting' });
  }

  handleUploadVersion(files) {
    this.setState({ versionFile: files[0] });
    this.handleUpload();
  }

  handleDateChange() {
    return (date) => {
      this.setState({ documentDate: date });
    }
  }

  isValid() {
    return !( this.state.fileNameInvalid || this.state.documentTypeInvalid);
  }

    //use blob storage account on api side
    uploadNew (result) {
      const { isVersionForm, projectId } = this.props;
      const file = isVersionForm ? this.state.versionFile : this.props.file;
      const callback = isVersionForm ? this.putDocumentToAPI : this.postDocumentToAPI;
      const currentTime = (new Date()).getTime() / 1000;

      // Replace original flename with a name entered by user
      const fileName = getFileName(file.name, this.state.fileName);
      const blobUrl = result.data.folderUri + `${currentTime}/` + fileName ;
      const url = `projects/${projectId}/documents/upload`;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('blobFilePath',  `${projectId.toUpperCase()}/${currentTime}/` + fileName);
      // Include a file length to be checked on a backend
      formData.append('contentLength', file.size);
      withAuth(
         {
          method: 'post', 
          url, 
          data: formData, 
          headers:{'Content-Type': 'multipart/form-data; boundary=${form._boundary}'} 
        },
        (response)=> {callback(blobUrl)}, 
        this.notifyError 
      )     

      function getFileName(originalName, enteredName) {
        let fileName = originalName;
        if (enteredName != undefined && enteredName.length > 0) {
          const nameParts = originalName.split(".");
          const ext = nameParts.length > 1 ? nameParts[nameParts.length - 1].trim() : "";
          fileName = `${enteredName.trim()}.${ext}`;
        }
        return fileName;
      }
  }

  deleteBlob(result) {
    const { doc, projectId } = this.props;
    const callback = this.delDocumentToAPI;
    const url = `projects/${projectId}/documents/delete`;
    const formData = new FormData();
    formData.append('blobFullFilePath', doc.blobUrl);
    withAuth(
      {
        method: 'post',
        url,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data; boundary=${form._boundary}' }
      },
      (response) => { callback(doc.blobUrl) },
      this.notifyError
    )
  }

  //Original
  // uploadNew (result) {
  //       const { isVersionForm } = this.props;
  //       const file = isVersionForm ? this.state.versionFile : this.props.file;
  //       const callback = isVersionForm ? this.putDocumentToAPI : this.postDocumentToAPI;
  //   // To avoid name collisions, upload to a directory with timestamp as its name.
  //       const currentTime = (new Date()).getTime() / 1000;
  //       const url = (
  //     result.data.folderUri + `${currentTime}/` +
  //     encodeURIComponent(file.name) +
  //     result.data.signature
  //   );

  //   // https://docs.microsoft.com/en-us/rest/api/storageservices/put-blob
  //       axios.put(url, file, {
  //           headers: {
  //               'x-ms-blob-type': 'BlockBlob',
  //               'x-ms-blob-content-type': file.type,
  //               'x-ms-meta-uploadvia': 'SAS Demo',
  //           }
  //       })
  //   .then(callback)
  //   .catch(this.notifyError);
  //   }

  // deleteBlob (result) {
  //     const { doc, file } = this.props;
  //     const callback = this.delDocumentToAPI;

  //     const url = doc.blobUrl + result.data.signature;
  // //https://benchmarkqa.blob.core.windows.net/documents/ACEDOS501/1516897392.113/Tulips.jpg
  // // https://docs.microsoft.com/en-us/rest/api/storageservices/put-blob
  //     axios.delete(url, {
  //         headers: {
  //             'x-ms-blob-type': 'BlockBlob',
  //             'x-ms-blob-content-type': file.type,
  //             'x-ms-meta-uploadvia': 'SAS Demo',
  //         }
  //     })
  // .then(callback)
  // .catch(this.notifyError);
  // }

  postDocumentToAPI(blobUrl) {
    const { projectId, file } = this.props;
    const { fileName, tags, documentDate } = this.state;
    let { documentType } = this.state;
    const endpoint = `projects/${projectId}/documents`;
    const payload = {
      projectId: projectId.toUpperCase(),
      contentType: file.type,
      contentLength: file.size,
      modifiedDate: file.lastModifiedDate,
      documentType: documentType.value,
      documentDate,
      version: 1,
      tags,
      fileName,
      blobUrl
    }

    withAuth(
      { method: 'post', url: endpoint, data: payload },
      () => this.props.onUploaded(this.props.index),
      this.notifyError
    )

    this.setState({ progressText: 'saving' });
  }

  // original  
  //   postDocumentToAPI (result) {
  //     const { projectId, file } = this.props;
  //     const { fileName, tags, documentDate } = this.state;
  //     let { documentType } = this.state;

  //     const blobUrl = decodeURI(result.config.url.split('?')[0]);
  //     const endpoint = `projects/${projectId}/documents`;
  //     const payload = {
  //         projectId: projectId,
  //         contentType: file.type,
  //         contentLength: file.size,
  //         modifiedDate: file.lastModifiedDate,
  //         documentType: documentType.value,
  //         documentDate,
  //         version: 1,
  //         tags,
  //         fileName,
  //         blobUrl
  //     }

  //     withAuth(
  //   {method: 'post', url: endpoint, data: payload},
  //   () => this.props.onUploaded(this.props.index),
  //   this.notifyError
  // )

  //     this.setState({progressText: 'saving'});
  // }

  putDocumentToAPI(blobUrl) {
    const { doc } = this.props;
    const { fileName, documentType, tags, documentDate } = this.state;
    const endpoint = `projects/${doc.projectId}/documents/${doc.id}`;

    if (this.props.isVersionForm) {
      doc.version = parseInt(doc.version, 10) + 1;
      doc.blobUrl = blobUrl;
    }

    const payload = {
      ...doc,
      fileName,
      documentType: documentType.value,
      tags,
      documentDate: documentDate ? documentDate.slice(0, 10) : null
    }
    withAuth(
      { method: 'put', url: endpoint, data: payload },
      () => this.props.onUploaded(this.props.index),
      this.notifyError
    )
    this.setState({ progressText: 'saving' });
  }

  //   putDocumentToAPI (result) {
  //     const { doc } = this.props;
  //     const { fileName, documentType, tags, documentDate } = this.state;
  //     const endpoint = `projects/${doc.projectId}/documents/${doc.id}`;

  //     if (this.props.isVersionForm) {
  //         doc.version = parseInt(doc.version, 10) + 1;
  //         doc.blobUrl = decodeURI(result.config.url.split('?')[0]);
  //     }

  //     const payload = {
  //         ...doc,
  //         fileName,
  //         documentType: documentType.value,
  //         tags,
  //         documentDate: documentDate ? documentDate.slice(0, 10) : null
  //     }

  //     withAuth(
  //   {method: 'put', url: endpoint, data: payload},
  //   () => this.props.onUploaded(this.props.index),
  //   this.notifyError
  // )

  //     this.setState({progressText: 'saving'});
  // }
  delDocumentToAPI(result) {
    const { doc } = this.props;
    const { fileName, documentType, tags } = this.state;
    const endpoint = `projects/${doc.projectId}/documents/${doc.id}`;

    if (this.props.isVersionForm) {
      doc.version = parseInt(doc.version, 10) + 1;
      doc.blobUrl = decodeURI(result.config.url.split('?')[0]);
    }

    const payload = {
      ...doc,
      fileName,
      documentType: documentType.value,
      tags,
    }
    withAuth(
      { method: 'delete', url: endpoint, data: payload },
      () => this.props.onDeleted(),
      this.notifyError
    )

    this.setState({ progressText: 'deleting' });
  }

  notifyError() {
    // Let us not show any complex message from the server to the user.
    // In case you want to see that error message, use this:
    // const errorText = error.response.data.message;
    const errorText = 'There seems to be an error';
    this.setState({ errorText, progressText: '' });
  }

  renderPreview() {
    if (this.props.doc) return null;
    return (
      <div className="doc-preview">
        <FilePreview file={this.props.file} />
      </div>
    )
  }

  renderError() {
    const { errorText } = this.state;
    if (errorText.length === 0) return null;
    return (
      <div className="overlay">
        <div className="doc-error">
          {errorText}
          <button onClick={this.handleCancel}>Close and Retry</button>
        </div>
      </div>
    );
  }

  renderActions(isDeleteForm) {
    const { progressText, errorText } = this.state;
    if (progressText.length || errorText.length) return null;

    const isValid = this.isValid();
    return (
      <div className="actions">
        {this.props.doc
          ? !isDeleteForm && <button className="doc-put" disabled={!isValid} onClick={this.putDocumentToAPI}>Save</button>
          : !isDeleteForm && <button className="doc-save" disabled={!isValid} onClick={this.handleUpload}>Upload</button>
        }
        {isDeleteForm && <button className="btn-delete" disabled={!isValid} onClick={this.handleDelete}>Delete</button>}
        <button className="doc-cancel" onClick={this.handleCancel}>Cancel</button>
      </div>
    )
  }

  renderVersionForm() {
    const { progressText } = this.state;
    return (
      <DropZone
        multiple={false}
        className="dropzone"
        onDrop={this.handleUploadVersion}
      >
        {progressText.toUpperCase() || 'DROP HERE or CLICK, to upload one file.'}
      </DropZone>
    );
  }
  renderNewForm() {
    const { progressText, fileNameInvalid, documentTypeInvalid, documentDate } = this.state;
    const { isDeleteForm} = this.props;
    const tags = this.state.tags.map(t => t.value);
    return (
      <div className="document-form">
        {this.renderPreview()}
        <div className={'required doc-filename' + (fileNameInvalid ? ' has-error' : '')}>
          <label htmlFor="fileName">Name</label>
          <input name="fileName"
            type="text"
            value={this.state.fileName}
            onChange={this.handleNameChange}
            disabled={isDeleteForm}
          />
          {
            (this.state.fileNameInvalid) && (
              <div className="warning-message">
                {this.state.fileName.length === 0 ? "File Name is Required" : "File name must not be more than 150 characters."}
              </div>)
          }
        </div>
        <div className={'control required' + (documentTypeInvalid ? ' has-error' : '')}>
          <label htmlFor="documentType">Document Type</label>
          <Select
            name="documentType"
            value={this.state.documentType.value}
            options={documentTypeOptions}
            onChange={this.handleTypeChange}
            disabled={isDeleteForm}
          />        
        </div>
        <div className="control tags-container">
            <label htmlFor="documentTags">Tags</label>
            <Creatable name="documentTags"
              value={tags} multi={true}
              options={this.props.documentTags}
              onChange={this.handleTagsChange}
            />
        </div>
        <div className="controls date-control">
          <DateField name="documentDate"
            limits={{}}
            value={documentDate}
            placeholder="Document Date..."
            disableManualEntry={true}
            onChange={this.handleDateChange()} />
        </div>

        {progressText.length
          ? <div className="doc-progress">
            {progressText} <span className="loader"></span>
          </div>
          : null}

        {this.renderError()}
        {this.renderActions(isDeleteForm)}

      </div>
    );
  }

  renderEditForm() {
    const { documentTypeInvalid, documentDate } = this.state;
    const { isDeleteForm } = this.props;
    const tags = this.state.tags.map(t => t.value);
    return (
      <div className="document-form">
        <div className="doc-filename">
          <label htmlFor="fileName">Name</label>
          <div name="fileName" id="fileName">{this.state.fileName}</div>
        </div>
        <div className={'doc-type control required' + (documentTypeInvalid ? ' has-error' : '')}>
          <label htmlFor="documentType">Document Type</label>
          <Select
              id="documentType"
              name="documentType"
              value={this.state.documentType.value}
              options={documentTypeOptions}
              onChange={this.handleTypeChange}
            />
        </div>
        <div className="control tags-container">
            <label htmlFor="documentTags">Tags</label>
            <Creatable name="documentTags"
              value={tags} multi={true}
              options={this.props.documentTags}
              onChange={this.handleTagsChange}
            />
        </div>
        <div className="controls date-control">
          <DateField name="documentDate"
            limits={{}}
            value={documentDate}
            placeholder="Document Date..."
            disableManualEntry={true}
            onChange={this.handleDateChange()} />
        </div>

        {this.renderError()}
        {this.renderActions(isDeleteForm)}
      </div>
    );
  }
  
  renderDeleteForm() {
    const { isDeleteForm } = this.props;
    return (
      <div className="document-form">
        <div className="doc-filename">
          <label htmlFor="fileName">Name</label>
          <div name="fileName" id="fileName">{this.state.fileName}</div>          
        </div>
        <div className="doc-type control">
          <label htmlFor="documentType">Document Type</label>
          <div name="documentType" id="documentType">{this.state.documentType.label}</div>
         
        </div>
        {this.renderActions(isDeleteForm)}
      </div>
    );
  }

  render () {
      // const { progressText, fileNameInvalid, documentTypeInvalid, documentDate } = this.state;
      // const tags = this.state.tags.map(t => t.value);
      const { isVersionForm, isDeleteForm, isNewDocument } = this.props;

      if (isVersionForm) return this.renderVersionForm();
      if (isNewDocument) return this.renderNewForm();
      if (isDeleteForm) return this.renderDeleteForm();
      return this.renderEditForm();
  }
}

DocumentForm.defaultProps = {
  isVersionForm: false,
}

DocumentForm.propTypes = {
    projectId: PropTypes.string.isRequired,
    doc: PropTypes.object,
    file: PropTypes.object.isRequired,
    documentTags: PropTypes.array.isRequired,
    index: PropTypes.number,
    isVersionForm: PropTypes.bool,
    isDeleteForm: PropTypes.bool,
    isNewDocument: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onUploaded: PropTypes.func.isRequired,
    onDeleted: PropTypes.func.isRequired
};

export default DocumentForm;
